module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgwIiB3aWR0aD0iNjQwIiB2aWV3Qm94PSIwIDAgNjQwIDQ4MCI+CiAgPGcgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxwYXRoIGZpbGw9IiNmZmU3MDAiIGQ9Ik02NDAgNDgwSDBWMGg2NDB6Ii8+CiAgICA8cGF0aCBmaWxsPSIjMzZhMTAwIiBkPSJNNjQwIDE2MC4wMDNIMFYwaDY0MHoiLz4KICAgIDxwYXRoIGZpbGw9IiMwMDZkYmMiIGQ9Ik02NDAgNDgwSDBWMzE5Ljk5N2g2NDB6Ii8+CiAgPC9nPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/4x3/ga.svg
// module id = ./node_modules/flag-icon-css/flags/4x3/ga.svg
// module chunks = 0